// src/components/ListasTrabajo/GestionListas/MisListasUnificadas.js

import React, { useState } from 'react';
import { Box, Paper, Tabs, Tab } from '@mui/material';
import GavelIcon from '@mui/icons-material/Gavel';
import DescriptionIcon from '@mui/icons-material/Description';

import ListasTrabajoPanel from './ListasTrabajoPanel';

const MisListasUnificadas = () => {
    const [tipoActivo, setTipoActivo] = useState(1); // 1=Judicial, 2=Administrativo

    return (
        <div>
            {/* Paper contenedor con Tabs integrados */}
            <Paper sx={{ p: 2, borderRadius: '4px' }}>
                <Tabs
                    value={tipoActivo}
                    onChange={(_e, newValue) => setTipoActivo(newValue)}
                    indicatorColor="primary"
                    textColor="primary"
                    centered
                >
                    <Tab
                        label="Expedientes Judiciales"
                        value={1}
                        icon={<GavelIcon />}
                    />
                    <Tab
                        label="Expedientes Administrativos"
                        value={2}
                        icon={<DescriptionIcon />}
                    />
                </Tabs>

                {/* Panel de listas segun tipo */}
                <Box mt={1.5}>
                    <ListasTrabajoPanel tipoExpediente={tipoActivo} />
                </Box>
            </Paper>
        </div>
    );
};

export default MisListasUnificadas;